"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var useSelector_1 = __importDefault(require("./useSelector"));
var utils_1 = __importDefault(require("../utils"));
var actions_1 = __importDefault(require("../actions"));
var selectors_1 = __importDefault(require("../selectors"));
var utils_2 = require("../utils/utils");
var useBrandDetailsData = function (_a) {
    var brandId = _a.brandId, isShow = _a.isShow, initialRailSize = _a.initialRailSize, isPpv = _a.isPpv, _b = _a.skipFetchWhenMount, skipFetchWhenMount = _b === void 0 ? false : _b;
    var _c;
    var dispatch = react_redux_1.useDispatch();
    var brand = useSelector_1.default(selectors_1.default.titles.getBrand)(brandId);
    var isLoading = useSelector_1.default(selectors_1.default.titles.brandIsLoading);
    var defaultSelectedSeason = useSelector_1.default(selectors_1.default.titles.getSelectedSeason)(brandId);
    var highlights = useSelector_1.default(selectors_1.default.titles.showHighlights)(brandId);
    var brandIsLoading = useSelector_1.default(selectors_1.default.titles.brandIsLoading);
    var brandError = useSelector_1.default(selectors_1.default.titles.brandError);
    var parentalPinIsLoading = useSelector_1.default(selectors_1.default.parentalPin.isLoading);
    var characters = isShow ? (_c = brand === null || brand === void 0 ? void 0 : brand.defaultEpisode) === null || _c === void 0 ? void 0 : _c.characters : brand === null || brand === void 0 ? void 0 : brand.characters;
    var synopsis;
    var isSport;
    var cast;
    var defaultWhatsOnTVTab;
    var hasNextPage;
    var paginationLoading;
    if (utils_2.isNotNilOrEmpty(brand)) {
        synopsis = utils_1.default.hero.getSynopsis(brand);
        isSport = utils_1.default.title.isSport(brand);
        cast = utils_1.default.title.getCharactersText(characters);
        defaultWhatsOnTVTab = utils_1.default.title.getDefaultWhatsOnTVTab(brand);
    }
    if (utils_2.isNotNilOrEmpty(highlights === null || highlights === void 0 ? void 0 : highlights.content)) {
        hasNextPage = utils_1.default.pagination.hasNextPage(highlights);
        paginationLoading = utils_1.default.pagination.isLoading(highlights);
    }
    var onHighlightsPaginate = react_1.useCallback(function (nextPageSize) {
        dispatch(actions_1.default.titles.fetchShowHighlights(brandId, nextPageSize));
    }, [brandId, dispatch]);
    var getBrandImage = react_1.useCallback(function (defaultBrandImage) { return brand && utils_1.default.hero.getImage(brand, defaultBrandImage); }, [brand]);
    react_1.useEffect(function () {
        if (brandId && !skipFetchWhenMount) {
            dispatch(actions_1.default.titles.fetchBrand({ brandId: brandId, isShow: isShow, isPpv: isPpv, initialRailSize: initialRailSize }));
        }
    }, [brandId, isShow, dispatch, initialRailSize, isPpv, skipFetchWhenMount]);
    var fetchBrand = react_1.useCallback(function () { return dispatch(actions_1.default.titles.fetchBrand({ brandId: brandId, isShow: isShow, isPpv: isPpv })); }, [brandId, isShow, dispatch, isPpv]);
    var onSelectSeason = react_1.useCallback(function (seasonId) {
        dispatch(actions_1.default.titles.selectSeason(brandId, seasonId));
    }, [brandId, dispatch]);
    return {
        isLoading: isLoading,
        brand: brand,
        isSport: isSport,
        defaultSelectedSeason: defaultSelectedSeason,
        highlights: highlights,
        onHighlightsPaginate: onHighlightsPaginate,
        synopsis: synopsis,
        cast: cast,
        onSelectSeason: onSelectSeason,
        fetchBrand: fetchBrand,
        brandIsLoading: brandIsLoading,
        brandError: brandError,
        parentalPinIsLoading: parentalPinIsLoading,
        defaultWhatsOnTVTab: defaultWhatsOnTVTab,
        hasNextPage: hasNextPage,
        paginationLoading: paginationLoading,
        getBrandImage: getBrandImage,
    };
};
exports.default = useBrandDetailsData;
//# sourceMappingURL=useBrandDetailsData.js.map